import { useEffect, useState } from "react";

const storageKey = "captex_recent_searches";
const maxItems = 8;

export function useRecentSearches() {
  const [recentSearches, setRecentSearches] = useState([]);

  useEffect(() => {
    const stored = window.localStorage.getItem(storageKey);

    if (stored) {
      setRecentSearches(JSON.parse(stored));
    }
  }, []);

  const saveSearch = (query) => {
    const value = query.trim();

    if (!value) return;

    const nextSearches = [
      value,
      ...recentSearches.filter((item) => item.toLowerCase() !== value.toLowerCase()),
    ].slice(0, maxItems);

    setRecentSearches(nextSearches);
    window.localStorage.setItem(storageKey, JSON.stringify(nextSearches));
  };

  const clearSearches = () => {
    setRecentSearches([]);
    window.localStorage.removeItem(storageKey);
  };

  return {
    recentSearches,
    saveSearch,
    clearSearches,
  };
}